import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';

export const getVulnerability = createAsyncThunk(
  '/getVulnerability',
  async () => {
    const response = await axios.get('/GetVulnerability');
    return response.data;
  }
);

export const getVulnerabilityDetails = createAsyncThunk(
  '/getVulnerabilityDetails',
  async (id) => {
    const response = await axios.get(`/GetVulnerabilityDetails/${id}`);
    return response.data;
  }
);

export const getLanguagelist = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axios.get('/GetLanguageList');
    return response.data;
  }
);

const vulnerabilitySlice = createSlice({
  name: 'vulnerabilities',
  initialState: {
    loading: false,
    error: '',
    Vulnerabilities: [],
    VulnerabilityDescriptions: [],
    SelectedAppTranslationId: 0,
    IsChecked: true,
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
    },

    resetDescriptions(state) {
      state.VulnerabilityDescriptions = [];
    },
    changeIsChecked(state, action) {
      state.IsChecked = action.payload;
    }
  },

  extraReducers: {
    [getVulnerability.pending]: (state) => {
      state.loading = true;
    },
    [getVulnerability.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getVulnerability.fulfilled]: (state, action) => {
      state.Vulnerabilities = action.payload;
      state.loading = 'Finished';
      state.loading = false;
    },
    [getVulnerabilityDetails.pending]: (state) => {
      state.loading = true;
    },
    [getVulnerabilityDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getVulnerabilityDetails.fulfilled]: (state, action) => {
      state.VulnerabilityDescriptions = action.payload;
      state.loading = false;
    },
    [getLanguagelist.pending]: (state) => {
      state.loading = true;
    },
    [getLanguagelist.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguagelist.fulfilled]: (state, action) => {
      state.VulnerabilityDescriptions = action.payload;
      state.loading = false;
    }
  }
});

export const vulnerabilityActions = vulnerabilitySlice.actions;

export default vulnerabilitySlice;
